<template>
  <!-- 宣传图管理 -->
  <div class="container">
    <div class="add-bar">
      <el-button type="primary" @click="addBanner" size="small" icon="el-icon-circle-plus-outline">新增</el-button>
    </div>
    <el-table 
    :header-cell-style="{ fontWeight: 400,background:'#F0F5FC',color:'#333333'}"
    :data="tableData" border style="100%">
      <el-table-column prop="" label="序号" width="180" type="index"></el-table-column>
      <el-table-column prop="image" label="banner图">
        <template v-slot="scope">
          <!-- <el-image
          v-if="scope.row.promotionUrl"
            :src="
              projectName +
              '/common/backstage/file/fileDownLoad?filePath=' +
              encodeURIComponent(scope.row.promotionUrl)
            "
            class="image-one"
            :preview-src-list="[
              projectName +
                '/common/backstage/file/fileDownLoad?filePath=' +
                encodeURIComponent(scope.row.promotionUrl),
            ]"
          >
          </el-image> -->
          <img v-if="scope.row.imgs" class="image-one" :src="scope.row.imgs" />
        </template>
      </el-table-column>
      <el-table-column prop="isJump" label="状态">
        <template v-slot="scope">
          <!-- <span>{{scope.row.status==1?'上架':'下架'}}</span> -->
          <div class="states starts" v-if="scope.row.status == 1">
            <img src="@/assets/tableIcon/start.png" class="imgstates" />
            <span class="ml15">上架</span>
          </div>
          <div class="states stops" v-if="scope.row.status == 0">
            <img src="@/assets/tableIcon/stop.png" class="imgstates" />
            <span class="ml15">下架</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="operation" label="操作" width="240">
        <template slot-scope="scope">
            <el-tooltip class="item pointer" effect="dark" content="编辑" placement="top">
                <img src="@/assets/tableIcon/edit.png" @click="editOption(scope.row)" />
            </el-tooltip> 
            <el-tooltip v-if="scope.row.status==0" class="item pointer ml10" effect="dark" content="上架" placement="top">
                <img src="@/assets/tableIcon/shangjia.png" @click="isGrounding(scope.row)" />
            </el-tooltip> 
            <el-tooltip v-if="scope.row.status==1" class="item pointer ml10" effect="dark" content="下架" placement="top">
                <img src="@/assets/tableIcon/xiajia.png" @click="isGrounding(scope.row)" />
            </el-tooltip> 
            <el-tooltip v-if="scope.row.status==0" class="item pointer ml10" effect="dark" content="删除" placement="top">
                <img src="@/assets/tableIcon/delete.png" @click="deleteOption(scope.row)" />
            </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.current"
            :page-size="listQuery.size"
            layout="total, prev, pager, next, jumper"
            :total="listQuery.total"
        >
        </el-pagination>
    </div>
    <!-- 新增弹框 -->
    <div class="dialogVisible">
      <el-dialog 
      :show-close="false"
      :close-on-click-modal="false"
      :title="titleName" 
      :visible.sync="adDialogVisible" width="30%">
        <div>
          <el-form label-position="right" label-width="130px" v-model="form">
            <el-form-item label="banner图：">
              <div class="upload-image1">
                <el-upload
                  class="avatar-uploader1"
                  :action="projectName + '/common/backstage/file/fileupload'"
                  :headers="headers"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
          <img 
          class="avatar1"
          v-if="promotionUrl"
          :src="promotionUrl">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelClick" size="small">取 消</el-button>
          <el-button type="primary" @click="submit" size="small">确 定</el-button>
          <!-- <el-button type="primary" @click="editSubmit" size="small" v-else>确 定</el-button> -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  sysPromotionList,
  saveOrUpdatePromotion,
  sysPromotionDeleteId,
  updateStatus,
  fileDownLoad
} from "@/api/systemManagement.js"
import { projectName } from "@/util/config";
export default {
  data() {
    return {
      tableData: [],
      adDialogVisible: false,
      titleName:"",
      projectName:projectName,
      headers: {
        sessionId: sessionStorage.getItem("access_token"),
        tenantId: '-1' 
      },
      form: {
        promotionUrl:"",//banner图
      },
      listQuery:{
        current: 1,
        size: 10,
        total: 0,
        type: 0
      },
      promotionUrl: ''
    };
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    getTableData() {
      let data = {
        ...this.listQuery
      }
      sysPromotionList(data).then(res=>{
        if(res.code==1) {
          const dataList = res.data.records || [];
          for(let i = 0; i<dataList.length;i++) {
            fileDownLoad({ filePath: dataList[i].promotionUrl }).then((res) => {
              const reader = new FileReader();
              reader.onload = (e) => {
                dataList[i].imgs = e.target.result;
              };
              reader.readAsDataURL(res.data);
            });
          }
          this.tableData = dataList || []

          this.listQuery.total = res.data.total || 0
        }
      })
    },
    isGrounding(row) {
      var status = null;
      if(row.status == 0) {
        status = 1
      } else {
        status = 0
      }
      let data = {
        sysPromotionId:row.sysPromotionId,
        status:status
      }
      updateStatus(data).then(res=>{
        if(res.code==1) {
          if(status ==1) {
            this.$message.success("已上架！")
          } else {
            this.$message.success("已下架！")
          }
          this.getTableData()
        }
      })
    },
    handleCurrentChange(current) {
      this.listQuery.current = current;
      this.getTableData()
    },
    addBanner() {
      this.adDialogVisible = true;
      this.form.promotionUrl = ""
      this.titleName = '新增宣传图'
    },
    handleAvatarSuccess(res, file) {
      let data = res.data.nginxFileReadPath
      this.$set(this.form,"promotionUrl",data)
      // 图片回显
      fileDownLoad({filePath:data,downloadOrRead: 'download'}).then(res=>{
        const reader = new FileReader();
        reader.onload = (e) => {
          this.promotionUrl = e.target.result;
        };
        reader.readAsDataURL(res.data);
      })
    },
    
    beforeAvatarUpload(file) {},
    cancelClick() {
      this.form.nginxFileReadPath = "";
      this.promotionUrl = "";
      this.adDialogVisible = false;
      this.form = {...this.form}
    },
    submit() {
      let data = {
        ...this.form,
        imgs: ''
      }
      if(this.form.promotionUrl == '') {
        return this.$message.error("请上传banner图")
      }
      // console.log(data,"ffffff")
      saveOrUpdatePromotion(data).then(res=>{
        if(res.code==1) {
          this.$message.success("新增成功！");
          this.adDialogVisible = false;
          this.form.promotionUrl = '';
          this.getTableData()
        }
      })
    },
    editOption(row) {
      console.log(row,"rowrowrowrow")
      this.adDialogVisible = true;
      this.titleName = '编辑宣传图';
      this.form = {...row}
      // 图片回显
      fileDownLoad({filePath:row.promotionUrl,downloadOrRead: 'download'}).then(res=>{
        const reader = new FileReader();
        reader.onload = (e) => {
          this.promotionUrl = e.target.result;
        };
        reader.readAsDataURL(res.data);
      })
      
      
    },
    deleteOption(row) {
      this.$confirm("是否确认删除此宣传图？", "提示", {
        confirmButtonText: "确定",
        concelButtonText: "取消",
        type: "warning",
      }).then(() => {
        sysPromotionDeleteId({sysPromotionId:row.sysPromotionId}).then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "删除成功！",
            });
            this.getTableData();
          }
        });
      });
    }
  },
};
</script>
<style lang="less" scoped>
.container {
    width: 100%;
  .add-bar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
}
.el-button--small {
  width: 80px;
}
.ml10r {
  margin-left: 10px;
}
.dialogVisible {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 278px;
    line-height: 278px;
    text-align: center;
    border: 1px dashed;
  }
  .avatar {
    width: 178px;
    height: 278px;
    display: block;
  }
  .upload-image1 {
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 300px;
      height: 78px;
      line-height: 78px;
      text-align: center;
      border: 1px dashed;
    }
    .avatar1 {
      width: 300px;
      height: 78px;
      display: block;
    }
  }
  
  
}
.footer {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.image-one {
  width:250px;
  height: 70px;
}
.image-two {
  width: 80px;
  height: 150px;
}

.starts {
  background: #D6F7F1;
  color: #11D6A1;
}
.stops {
  background: #FFEEE1;
  color: #FF9446;
}
.states {
  width: 72px;
  height: 34px;
  border-radius: 17px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  
  text-align: center;
  line-height: 34px;
  position: relative;
}
.imgstates {
  position: absolute;
  left: 10px;
  top: 9px;
}
</style>
